import "/__w/1/s/BotFramework-WebChat/packages/component/src/hooks/RenderMarkdown.module_built.css";
const classes = {"render-markdown--message-activity":"wlkyN3a_render-markdown--message-activity","render-markdown--adaptive-cards":"wlkyN3a_render-markdown--adaptive-cards","render-markdown":"wlkyN3a_render-markdown"}
export default classes

const _render_markdown__message_activity0 = classes["render-markdown--message-activity"]
export { _render_markdown__message_activity0 as "render-markdown--message-activity" }

const _render_markdown__adaptive_cards0 = classes["render-markdown--adaptive-cards"]
export { _render_markdown__adaptive_cards0 as "render-markdown--adaptive-cards" }

const _render_markdown0 = classes["render-markdown"]
export { _render_markdown0 as "render-markdown" }
